type FilterName = 'airline' | 'airport' | 'from' | 'to' | 'reportedBy' | 'reason';

const FilterNameMap: Partial<Record<FilterName, string>> = {
  airline: 'Airline',
  airport: 'Airport',
  reportedBy: 'Reported By',
  reason: 'Reason',
};

interface FilterDisplay {
  displayName: string;
  value: any;
}

export const getFcrReporterDisplayName = (name: string) => {
  switch (name) {
    case 'FLIGHT_ATTENDANT':
      return 'Flight Attendant';
    case 'PILOT':
      return 'Pilot';
    default:
      return 'Unknown';
  }
};

export const getFilterDisplayName = (filterKey: string) => {
  return FilterNameMap[filterKey] || filterKey;
};

const filterToDisplay = (key: FilterName, value: any): FilterDisplay => {
  if (!(key in FilterNameMap)) return null;
  switch (key) {
    case 'airline':
      return { displayName: getFilterDisplayName(key), value: value?.join(', ') || 'All Airlines' };
    case 'airport':
      return { displayName: getFilterDisplayName(key), value: value?.join(', ') || 'All Airports' };
    case 'reason':
      return { displayName: getFilterDisplayName(key), value: value?.join(', ') || 'All Reasons' };
    case 'reportedBy': {
      return {
        displayName: getFilterDisplayName(key),
        value: value?.map((v) => getFcrReporterDisplayName(v)).join(', ') || 'All Reporters',
      };
    }
    default:
      return { displayName: key, value: value || '--' };
  }
};

export const convertFiltersToFiltersDisplay = (filters: Record<string, unknown>): FilterDisplay[] => {
  // Combine startDatetime and endDatetime into a single display value
  if (filters && Object.keys(filters).length > 0) {
    const start = filters['from'] && (filters['from'] as string);
    const end = filters['to'] && (filters['to'] as string);
    const displays: FilterDisplay[] = [];
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const sameDay = startDate.toDateString() === endDate.toDateString();
      const displayValue = sameDay
        ? startDate.toLocaleDateString()
        : `${startDate.toLocaleDateString()} to ${endDate.toLocaleDateString()}`;
      displays.push({ displayName: 'Date/Time', value: displayValue });
    }
    // Add all other filters except startDatetime and endDatetime
    Object.entries(filters).forEach(([key, value]: [string, { value: any }]) => {
      if (key === 'startDatetime' || key === 'endDatetime' || !value) return;
      const display = filterToDisplay(key as FilterName, value);
      if (display) displays.push(display);
    });
    return displays;
  }
  return [];
};
